import { ActionReducerMapBuilder, Draft, PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/dist/tsHelpers';

import { ModelError, SearchAktivitetState } from 'models';
import { SearchAktivitetCriteria } from 'models/apiModels/SearchAktivitetCriteria';
import { SearchAktivitetPost } from 'models/apiModels/SearchAktivitetPost';
import { SearchAktivitetResultSummary } from 'models/apiModels/SearchAktivitetResultSummary';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from './storeHelpers';

import BebyggelseApi from 'api/bebyggelseApi';

const initialState: SearchAktivitetState = {
  data: undefined,
  searchCriteria: undefined,
  error: undefined,
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined
};

export const searchAktivitet = createAsyncThunk<
  SearchAktivitetResultSummary,
  SearchAktivitetPost,
  { rejectValue: ModelError }
>('search/aktivitet', async (searchAktivitetPost: SearchAktivitetPost, { rejectWithValue }): Promise<any> => {
  const result = await BebyggelseApi.search.searchAktivitet(searchAktivitetPost);
  return errorOr(result, rejectWithValue);
});

const searchAktivitetSlice = createSlice({
  name: 'searchAktivitet',
  initialState,
  reducers: {
    clearSearchAktivitetResult: (state: Draft<SearchAktivitetState>) => {
      state.data = undefined;
    },
    setSearchCriteria: (state: Draft<SearchAktivitetState>, payloadAction: PayloadAction<SearchAktivitetCriteria>) => {
      state.searchCriteria = payloadAction.payload;
    },
    clearSearchCriteria: (state: Draft<SearchAktivitetState>) => {
      state.searchCriteria = undefined;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<SearchAktivitetState>>) => {
    builder.addCase(searchAktivitet.pending, (state: Draft<SearchAktivitetState>, action: PendingActionType): void => {
      pending(state, action);
    });
    builder.addCase(
      searchAktivitet.fulfilled,
      (state: Draft<SearchAktivitetState>, action: FulfilledActionType<SearchAktivitetResultSummary>): void =>
        fulfilled(state, action)
    );
    builder.addCase(searchAktivitet.rejected, (state: Draft<SearchAktivitetState>, action: RejectedActionType): void =>
      rejected(state, action)
    );
  }
});

export const { clearSearchAktivitetResult, setSearchCriteria, clearSearchCriteria } = searchAktivitetSlice.actions;

export default searchAktivitetSlice.reducer;
